<template>
  <div class="common_turn_page">
    <div
      v-show="toTopVisible" class="item to_top" title="回到顶部"
      @click="toTop" />
    <div
      v-show="hasBeforeVisible" title="上一页" :class="{ 'disable': !hasBefore }" class="item before"
      @click="before" />
    <div
      v-show="hasNextVisible" title="下一页" :class="{ 'disable': !hasNext }" class="item next"
      @click="next" />
  </div>
</template>

<script>
export default {
  name: 'TurnPage',

  props: {
    toTopVisible: {
      type: Boolean,
      default: true
    },

    hasBeforeVisible: {
      type: Boolean,
      default: false
    },

    hasBefore: {
      type: Boolean,
      default: true
    },

    hasNextVisible: {
      type: Boolean,
      default: false
    },

    hasNext: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    toTop () {
      this.$emit('toTop')
    },

    before () {
      this.hasBefore && this.$emit('before')
    },

    next () {
      this.hasNext && this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.common_turn_page { width: 40px;
  .item { width: 100%; height: 40px; margin-bottom: 10px; cursor: pointer; background-size: cover; border-radius: 50%; box-shadow: $box_shadow_3;
    &.to_top { background-image: url(~@/assets/images/icon_to_top.svg);
      &:hover { background-image: url(~@/assets/images/icon_to_top_hover.svg); }
    }
    &.before { background-image: url(~@/assets/images/icon_before.svg);
      &:hover { background-image: url(~@/assets/images/icon_before_hover.svg); }
    }
    &.next { background-image: url(~@/assets/images/icon_before.svg); box-shadow: 0 -3px 8px 0 rgba(86, 94, 172, 0.3); transform: rotate(180deg);
      &:hover { background-image: url(~@/assets/images/icon_before_hover.svg); }
    }
    &.disable { background-image: url(~@/assets/images/icon_before_disable.svg);
      &:hover { background-image: url(~@/assets/images/icon_before_disable.svg); }
    }
  }
}

</style>
